import React from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import Button from "../form/Button";

const PdfGenerator = ({ children, data, fileName }) => {
  return (
    <div className="flex flex-col items-center p-5">
      {/* Hidden Download Link */}
      {data && Object.keys(data)?.length > 0 && (
        <>
          <PDFDownloadLink
            document={React.cloneElement(children, { data })}
            fileName={fileName || "download.pdf"}
          >
            {({ loading }) =>
              loading ? (
                <span className="text-gray-500 italic">Loading...</span>
              ) : (
                <Button
                  buttonClasses={
                    "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
                  }
                  buttonLabelClasses={"mx-auto"}
                  buttonLabel={"Click here to download"}
                />
              )
            }
            {/* {({ loading }) => (loading ? "Loading..." : "Download PDF")} */}
          </PDFDownloadLink>

          {/* PDF Preview */}
          <PDFViewer
            style={{ width: "100%", height: "700px", marginTop: "20px" }}
            fileName={fileName || "download.pdf"}
          >
            {React.cloneElement(children, { data })}
          </PDFViewer>
        </>
      )}
    </div>
  );
};

export default PdfGenerator;
